////////////////////////////////////
//  Header
////////////////////////////////////

function header(){
	$(document).on('click', '.js-hamburger', function(){
	  $(this).toggleClass("is-active");
	  $('body').toggleClass("is-active");
	  $(".js-menu").toggleClass("is-active");
      $(".header").toggleClass("is-active");
	  //$(".js-menu").fadeToggle(300);
	});
}

function headerAnime() {
  if($('.mv-slide__img')) {
      var showHeight = $('.mv-slide__img').height(); 
  } else {
	  var showHeight = 100; 
  }
  var scroll = $(window).scrollTop();
  if (scroll >= showHeight){
	  $('header').addClass("is-show");
      
  }else{
	  $('header').removeClass("is-show");
  }
  $('.header-nav__list li').each(function(index, element) {
      var childNum = $(this).find(".header-nav__list--level2").length;
      if (childNum > 0) {
        $(this).addClass('is-parents');
      }
  })
}

function headerAccord() {
  $(document).on('click', '.header-nav__list li i', function() {
      if(window.matchMedia('(max-width:767px)').matches){
        $(this).parents('li').toggleClass('is-active');
        $(this).prev('.header-nav__list--level2').slideToggle(); 
      }
   });
}

$(window).scroll(function () {
  headerAnime();
});

$(function(){
  headerAnime();
  headerAccord();
});

////////////////////////////////////
//  Main Visual
////////////////////////////////////

function mvSlide(){
	const mvSwiper = new Swiper('.js-mv', {
	  init: false,
	  speed: 1000,
	  autoplay: {
	    delay: 5000
	  },
	  loop: true,
	  allowTouchMove: true,
	  parallax: true,
	  pagination: {
	      el: ".swiper-pagination-mv",
	      clickable: true,
	   },
	});
	mvSwiper.on('init', function () {
		$('.mv-slide__txt h2 span').html('');
		$('.mv-slide__txt h3 span').html('');
		$('.mv-slide__link span').html('');
		let ttl = $('.swiper-slide-active').attr('date-ttl');
		let desc = $('.swiper-slide-active').attr('date-desc');
		let link = $('.swiper-slide-active').attr('date-link');
        let url = $('.swiper-slide-active').attr('date-url');
        if(url == '') {
          $('.mv-slide__link').hide();
        } else {
          $('.mv-slide__link').show();
        }
		$('.mv-slide__txt h2 span').append(ttl);
		$('.mv-slide__txt h3 span').append(desc);
        $('.mv-slide__link span').append(link);
        $('.mv-slide__link a').attr('href',url);
		$('.mv-slide__txt').addClass('is-active');
	});
	mvSwiper.on('slideChangeTransitionStart', function () {
		$('.mv-slide__txt').removeClass('is-active');
	});
	mvSwiper.on('slideChangeTransitionEnd', function () {
		$('.mv-slide__txt h2 span').html('');
		$('.mv-slide__txt h3 span').html('');
		$('.mv-slide__link span').html('');
		let ttl = $('.swiper-slide-active').attr('date-ttl');
		let desc = $('.swiper-slide-active').attr('date-desc');
		let link = $('.swiper-slide-active').attr('date-link');
        let url = $('.swiper-slide-active').attr('date-url');
        if(url == '') {
          $('.mv-slide__link').hide();
        } else {
          $('.mv-slide__link').show();
        }
		$('.mv-slide__txt h2 span').append(ttl);
		$('.mv-slide__txt h3 span').append(desc);
        $('.mv-slide__link span').append(link);
        $('.mv-slide__link a').attr('href',url);
		$('.mv-slide__txt').addClass('is-active');
	});
	mvSwiper.init();
}

////////////////////////////////////
//  Tab
////////////////////////////////////
  
function tab(){
  $('.js-tab__item').click(function() {
    var index = $(this).index();
    $('.js-tab__item').removeClass('is-active');
    $('.js-tabmain__item').removeClass('is-active').hide();
    $(this).addClass('is-active');
    $('.js-tabmain__item').eq(index).addClass('is-active').fadeIn();
    $('.js-tab__select').children().eq(index).prop('selected', true);
  });
}

////////////////////////////////////
//  Ranking Slide
////////////////////////////////////

function rankingSlide(){
	//ラッパー要素を指定
	var sliderWrap = document.querySelectorAll('.ranking-tab__item');
	//sliderWrapの数だけ繰り返す
	for (let i = 0; i < sliderWrap.length; i++) {
		var num = i + 1;
		console.log(num);
		//console.log('.js-activityList__slide' + (num));
		var explainSwiper = new Swiper ('.js-ranking__slide' + (num), {
			speed: 1000,
			autoplay: {
			  delay: 3000
			},
			loop: true,
			allowTouchMove: true,
			parallax: true,
			spaceBetween: 16,
			//centeredSlides: true,
			slidesPerView: 2,
			pagination: {
			  el: '.swiper-pagination-ranking' + (num),
			  clickable: true,
			},
			navigation: {
			   nextEl: ".swiper-ranking-next" + (num),
			   prevEl: ".swiper-ranking-prev" + (num),
			},
			breakpoints: {
			    961: {
			      slidesPerView: 4,
			      spaceBetween: 40,
			    }
			}
		});
	}
}


////////////////////////////////////
//  Product
////////////////////////////////////

function productSlide(index){
	const thumbClass = 'product__thumb--item';
	const mytap = window.ontouchstart === null?"touchstart":"click";
	const mySwiper = new Swiper('.js-product__slider', {
	  init: true,
	  speed: 1000,
	  autoplay: {
	    delay: 5000
	  },
	  loop: false,
	  allowTouchMove: true,
	  parallax: true,
	  pagination:{
	    el:'.js-product__thumb',
	    type:'custom',
	    renderCustom: function (swiper, current, total) {
	      const slides = swiper.slides;
	      let html = '';
	      for( let i = 0 ; i < total; i++ ){
	        if( current == i+1 ){
	          html = html + `<div class="${thumbClass} current" data-slideto="${i}">${slides[i].innerHTML}</div>`;
	        }else{
	          html = html + `<div class="${thumbClass}" data-slideto="${i}">${slides[i].innerHTML}</div>`;
	        }
	      }
	      return html;
	    }
	  }
	});

	const clickThumbs = (()=>{
	  const thumbItems = document.getElementsByClassName(thumbClass);
	  for(let i = 0; i < thumbItems.length ; i ++){
	    thumbItems[i].addEventListener(mytap,((e)=>{
	      let index = e.currentTarget.dataset.slideto;
	      mySwiper.slideTo(index, 1500, true);
	      // autoplayオプションを使わない場合は、以下をコメントアウトをする
	      setTimeout(mySwiper.autoplay.start,3000);
	    }),false);
	  }
	});

	clickThumbs();
	mySwiper.on('slideChange',clickThumbs);

}

////////////////////////////////////
//  Product
////////////////////////////////////

function linkCheck(){
    $('.color__selectors a').each(function(index) {
        var link = $(this).attr('link');
        let url = window.location.href;
        url = url.replace(location.search , '');
        console.log(url);
        console.log(link)
        if( link == url ) {
          $(this).addClass('is-current');
        }
     });
}
$(function(){
    tab();
    rankingSlide();
    header();
    mvSlide();
    productSlide(0);
    linkCheck();
});
